export * from "./localAddressBookResolver";
